import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/authentication/lib/CollectionsBootstrap'
import Page from 'modules/layout/components/Page'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Page>
        <Suspense>
          <Outlet />
        </Suspense>
      </Page>
    </CollectionsBootstrap>
  )
}

export default RootPage
